export const BuildInfo = {timestamp:1781022529000}
